export function normalizeYear(year) {
  if (!year || year === '0') return null;
  return year;
}
